export default __webpack_public_path__ + "static/BASIC_Cognitive_letter_phone_recruitment_2020-3bd755187a7ce640987c04df22ec243d.pdf";